import { render, staticRenderFns } from "./edit-AI-bianzheng.vue?vue&type=template&id=c3f43930&scoped=true"
import script from "./edit-AI-bianzheng.vue?vue&type=script&lang=ts"
export * from "./edit-AI-bianzheng.vue?vue&type=script&lang=ts"
import style0 from "./edit-AI-bianzheng.vue?vue&type=style&index=0&id=c3f43930&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f43930",
  null
  
)

export default component.exports